<template>
  <div class="custom-collab-details-page">
    <!--<LinkWithIcon tag="RouterLink" class="custom-collab-details-page__back-link"
        :to="{ name: 'CustomerCustomCollabs', params: { communityId: customCollabClientPayload?.customerCollabInputs.customerId } }">
      <template #icon><IconEmbedded name="arrow-left_2-5" :size="17" /></template>

      <span>Custom Collabs</span>
    </LinkWithIcon>
    <div class="custom-collab-details-page__divider"></div>
    -->

    <Loader v-if="isLoading" />

    <template v-else>
      <h1 class="global-h1 custom-collab-details-page__title">
        {{ collabTitle }}
      </h1>

      <div class="custom-collab-details-page__content">
        <div class="custom-collab-details-page__content-left-col">
          <div class="custom-collab-details-page__content-left-col-in-wrap1">
            <div
              class="custom-collab-details-page__content-left-col-in-wrap2"
              ref="domRefMsgThreadContainer"
              :style="
                ['mobile', 'tablet'].includes(screenSize)
                  ? null
                  : {
                      height: `calc(100dvh - ${msgThreadContainerViewportTopIndent >= 0 ? msgThreadContainerViewportTopIndent : 0}px)`,
                      minHeight: `calc(100dvh - ${msgThreadContainerViewportTopIndent >= 0 ? msgThreadContainerViewportTopIndent : 0}px)`,
                      maxHeight: `calc(100dvh - ${msgThreadContainerViewportTopIndent >= 0 ? msgThreadContainerViewportTopIndent : 0}px)`,
                    }
              "
            >
              <div v-if="['mobile', 'tablet'].includes(screenSize)" class="custom-collab-details-page__white-snippet-wrap" style="flex-grow: 1; display: flex; flex-direction: column">
                <SrpDetailsSummary isOpened>
                  <template #heading>
                    <h2 class="global-h2">
                      <span><span>Messages</span></span>
                    </h2>
                  </template>
                  <template #details>
                    <CollabMessagesThread
                      class="custom-collab-details-page__messages-thread"
                      ref="domRefCollabMessagesThread"
                      :isImpersonating="isImpersonating"
                      :isAutoFocusTextarea="false"
                      :isMsgBubblesFullWidth="true"
                      :messageThreadId="customCollabClientPayload?.customerCollabInputs?.messageThreadId"
                      :customerId="customCollabClientPayload?.customerCollabInputs?.customerId"
                      messageSenderType="CustomerId"
                      :customCollabId="customCollabClientPayload?.customerCollabInputs?.id"
                      :isEscalateContextVisible="false"
                      :hideShrpaName="true"
                    />
                  </template>
                </SrpDetailsSummary>
              </div>

              <div v-else class="custom-collab-details-page__white-snippet-wrap" style="flex-grow: 1; min-height: 100%; padding: 0 0 15px; display: flex; flex-direction: column">
                <h2 class="global-h2" style="margin: 20px 24px 20px">Messages</h2>

                <div class="custom-collab-details-page__messages-thread-wrap">
                  <CollabMessagesThread
                    class="custom-collab-details-page__messages-thread"
                    ref="domRefCollabMessagesThread"
                    :isImpersonating="isImpersonating"
                    :isAutoFocusTextarea="false"
                    :isMsgBubblesFullWidth="true"
                    :messageThreadId="customCollabClientPayload?.customerCollabInputs?.messageThreadId"
                    :customerId="customCollabClientPayload?.customerCollabInputs?.customerId"
                    messageSenderType="CustomerId"
                    :customCollabId="customCollabClientPayload?.customerCollabInputs?.id"
                    :isEscalateContextVisible="false"
                    :hideShrpaName="true"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="custom-collab-details-page__gray-snippet-wrap">
            <ContactShrpaAndEmails
              :pageId="customerId"
              :contactEmails="customCollabClientPayload?.customerCollabInputs.contactEmail"
              :isSaving="false"
              :showContactShrpa="false"
              :collabName="null"
              @saveEmails="saveContactEmail"
            />
          </div>
        </div>

        <div class="custom-collab-details-page__content-right-col">
          <WorkStatusSnippet class="custom-collab-details-page__work-status-snippet" :customCollabClientPayload="customCollabClientPayload" @markComplete="showMarkAsCompleteModal = true" />

          <CollabDetailsForm
            class="custom-collab-details-page__collab-details-snippet"
            :customCollabClientPayload="customCollabClientPayload"
            :isOpened="hasCollabInputsSet"
            @save="save"
            :isSaving="isSaving"
            @showSendForCreatorAcceptance="showSendForCreatorAcceptanceModal = true"
            @fillWithAI="fillCustomerFieldsWithAI"
            :isFillingWithAI="isFillingWithAI"
            :messagesCount="messagesCount"
          />

          <HowItWorks class="custom-collab-details-page__how-it-works-snippet" :isOpened="!hasCollabInputsSet" />
        </div>
      </div>

      <div style="margin-top: 30px; display: flex; justify-content: flex-end; width: 100%">
        <SuperUserActionPanel>
          <div>
            <router-link
              v-if="customCollabClientPayload.customerCollabInputs.creatorId"
              :to="{
                name: 'CreatorCustomCollabDetails',
                params: {
                  creatorId: customCollabClientPayload.customerCollabInputs.creatorId,
                  communityId: customCollabClientPayload.customerCollabInputs.customerId,
                  customCollabId: customCollabClientPayload.customerCollabInputs.id,
                },
              }"
              style="margin-right: 12px"
            >
              <SrpButton color="gray" fill="outlined" size="tiny" style="opacity: 0.5">Creator View</SrpButton>
            </router-link>
            <SrpButton size="tiny" fill="outlined" color="gray" @click="showDeleteModal = true" style="opacity: 0.5">Hard Delete</SrpButton>
          </div>
          <div style="margin-top: 10px">
            <MessagingImpersonateCheckbox v-model:isImpersonating="isImpersonating" />
          </div>
        </SuperUserActionPanel>
      </div>
      <SrpModal :isVisible="showDeleteModal">
        <template #header>
          <h1>Confirm Delete</h1>
        </template>
        <template #content>
          <p>
            Are you sure you want to delete this?<br />
            It will be perminently deleted.
          </p>
        </template>
        <template #footer>
          <SrpButton color="red" @click="deleteCustomCollab" :isDisabled="isDeleting" style="margin-right: 10px">Yes, Delete</SrpButton>
          <SrpButton fill="outlined" @click="showDeleteModal = false" :isDisabled="isDeleting">Cancel</SrpButton>
        </template>
      </SrpModal>
    </template>
  </div>

  <SrpModal :isVisible="showSendForCreatorAcceptanceModal" :isClosable="!isSaving" :isCloseButtonVisible="!isSaving" @update:isVisible="showSendForCreatorAcceptanceModal = $event">
    <template #header>
      <h1>Send to Creator for Acceptance</h1>
    </template>
    <template #content>
      <p>
        Asks the Creator to formally agree to the details.<br />
        Edits can still be made after as needed, and the creator will be notified.
      </p>
    </template>
    <template #footer>
      <SrpButton @click="sendForCreatorAcceptance" :isDisabled="isSaving" style="margin-right: 10px">Send</SrpButton>
      <SrpButton fill="outlined" @click="showSendForCreatorAcceptanceModal = false" :isDisabled="isSaving">Cancel</SrpButton>
    </template>
  </SrpModal>

  <SrpModal :isVisible="showMarkAsCompleteModal" :isClosable="!isSaving" :isCloseButtonVisible="!isSaving" @update:isVisible="showMarkAsCompleteModal = $event">
    <template #header>
      <h1>Mark Collab Complete</h1>
    </template>
    <template #content>
      <p>This will mark the collab as complete and notify the creator.<br /></p>
    </template>
    <template #footer>
      <SrpButton @click="markAsComplete" :isDisabled="isSaving" style="margin-right: 10px">Mark Complete</SrpButton>
      <SrpButton fill="outlined" @click="showMarkAsCompleteModal = false" :isDisabled="isSaving">Cancel</SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { onMounted, ref, computed, inject, watch, Ref } from "vue";
import CustomerCustomCollabsRepo from "@repos/CustomerCustomCollabsRepo";
import { useRoute } from "vue-router";
import { useHead } from "@unhead/vue";
import router from "@/router";
import { hasAnyCustomerDetailsAdded } from "@helpers/CustomCollabsHelper";
import { MetricSender } from "@/helpers/MetricSender";

// Components
import LinkWithIcon from "@components/LinkWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import WorkStatusSnippet from "./WorkStatusSnippet.vue";
import CollabDetailsForm from "./CollabDetailsForm.vue";
import ContactShrpaAndEmails from "@views/PaidCollab/CollabSummary/ContactShrpaAndEmails.vue";
import HowItWorks from "./HowItWorks.vue";
import CollabMessagesThread from "@views/PaidCollab/CollabMessagesThread/index.vue";
import Loader from "@components/Loader/Loader.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import SrpModal from "@components/ui/SrpModal.vue";
import SuperUserActionPanel from "@components/SuperUserActionPanel.vue";
import MessagingImpersonateCheckbox from "@/components/MessagingImpersonateCheckbox.vue";

// Composables
import { useMsgThreadTopIndentDetection } from "@views/CustomCollabs/useMsgThreadTopIndentDetection";

// Types
import { CustomCollabClientPayload } from "@contracts/customCollabs";
import { ScreenSize } from "@contracts/screenSize";
import SrpDetailsSummary from "@components/ui/SrpDetailsSummary.vue";

// Global variables & injections
const globalRoot = inject("globalRoot") as any;
const screenSize = inject("screenSize") as Ref<ScreenSize>;

const route = useRoute();

// Load Custom collab =========================================================
const isLoading = ref<boolean>(true);
const customCollabClientPayload = ref<CustomCollabClientPayload | null>(null);

let customerId = ref<string>("");
let customCollabId = ref<string>("");
const hasCollabInputsSet = ref<boolean>(false);

onMounted(async () => {
  isLoading.value = true;

  customerId.value = String(route.params.pageId);
  customCollabId.value = String(route.params.customCollabId);
  customCollabClientPayload.value = await CustomerCustomCollabsRepo.getCustomCollab(customerId.value, customCollabId.value);

  if (hasAnyCustomerDetailsAdded(customCollabClientPayload.value?.customerCollabInputs, true)) {
    hasCollabInputsSet.value = true;
  }

  isLoading.value = false;

  MetricSender.sendMetric("Cust-ViewCustomCollabDetails", null);
});

// Add the saveContactEmail method
function saveContactEmail(emails: Array<string>) {
  customCollabClientPayload.value.customerCollabInputs.contactEmail = emails.join(";");
  save();
}

// Computed title with fallback ===============================================
const collabTitle = computed<string>(() => {
  return customCollabClientPayload.value?.customerCollabInputs.title ?? `Custom Collab with ${customCollabClientPayload.value?.creator?.creatorName}`;
});

// Set browser title ==========================================================
onMounted(setTitle);

function setTitle() {
  const title = `Custom Collabs - ${globalRoot?.orgInContext?.name ?? "Shrpa"}`;
  useHead({ title: () => title, meta: [{ name: "description", content: title }] });
}

// Saving logic ==============================================================
const isSaving = ref<boolean>(false);
async function save() {
  isSaving.value = true;

  // Clean up the Other Comps array
  customCollabClientPayload.value.customerCollabInputs.otherComp = customCollabClientPayload.value.customerCollabInputs.otherComp.filter(c => Boolean(c));

  const newCustomCollabClientPayload = await CustomerCustomCollabsRepo.saveCustomCollab(
    String(route.params.pageId),
    String(route.params.customCollabId),
    customCollabClientPayload.value.customerCollabInputs,
    isImpersonating.value
  );
  customCollabClientPayload.value.customerCollabInputs._etag = newCustomCollabClientPayload.customerCollabInputs._etag;
  // Have messages reload in case an update caused a message to be added
  refreshMessages();

  isSaving.value = false;
}

const domRefCollabMessagesThread = ref(null);
function refreshMessages() {
  domRefCollabMessagesThread.value?.loadMessages(true, true);
}

// Get messages count for button color
const messagesCount = computed<number>(() => {
  return domRefCollabMessagesThread.value?.getMessagesCount() || 0;
});

// Fill Customer Fields with AI =============================================
const isFillingWithAI = ref<boolean>(false);
async function fillCustomerFieldsWithAI() {
  // Save first
  await save();
  isSaving.value = true;
  isFillingWithAI.value = true;
  const newCustomCollabClientPayload = await CustomerCustomCollabsRepo.fillCustomerFieldsWithAI(String(route.params.pageId), String(route.params.customCollabId));
  // Overwrite the whole object since the server can set fields here.
  customCollabClientPayload.value.customerCollabInputs = newCustomCollabClientPayload;
  isFillingWithAI.value = false;
  isSaving.value = false;
}

// Send for Creator Acceptance ==============================================
const showSendForCreatorAcceptanceModal = ref<boolean>(false);
async function sendForCreatorAcceptance() {
  // Save first in case they made any changes
  await save();
  isSaving.value = true;
  const newCustomCollabClientPayload = await CustomerCustomCollabsRepo.formalizeCustomCollab(String(route.params.pageId), String(route.params.customCollabId));
  // Overwrite the whole object since the server sets fields here.
  customCollabClientPayload.value.customerCollabInputs = newCustomCollabClientPayload.customerCollabInputs;
  showSendForCreatorAcceptanceModal.value = false;
  isSaving.value = false;
}

// Mark as Complete =========================================================
const showMarkAsCompleteModal = ref<boolean>(false);
async function markAsComplete() {
  isSaving.value = true;
  const newCustomCollabClientPayload = await CustomerCustomCollabsRepo.markCustomCollabComplete(String(route.params.pageId), String(route.params.customCollabId));
  // Overwrite the whole object since the server sets fields here.
  customCollabClientPayload.value.customerCollabInputs = newCustomCollabClientPayload.customerCollabInputs;
  showMarkAsCompleteModal.value = false;
  isSaving.value = false;
}

// Delete collab ============================================================
const showDeleteModal = ref<boolean>(false);
const isDeleting = ref<boolean>(false);
async function deleteCustomCollab() {
  isDeleting.value = true;
  await CustomerCustomCollabsRepo.deleteCustomCollab(String(route.params.pageId), String(route.params.customCollabId));
  await router.push({ name: "CustomerCustomCollabs", params: { communityId: customerId.value } });
}

// Impersonate toggle =========================================================
const isImpersonating = ref<boolean>(false);

// Get msgThread container viewport top indent ================================
const domRefMsgThreadContainer = ref<HTMLElement | null>(null);

const { msgThreadContainerViewportTopIndent } = useMsgThreadTopIndentDetection(domRefMsgThreadContainer, isLoading);
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

// Custom collab details page =================================================
.custom-collab-details-page {
  width: $desktop-wide-right-col-width;
  margin: 0 auto;

  &__back-link {
    margin-bottom: 20px;
  }

  &__divider {
    margin-bottom: 30px;
    border-bottom: 1px rgba(0, 0, 0, 0.15) solid;
  }

  &__title {
    margin-bottom: 27px;
  }

  &__content {
    min-height: 700px;
    gap: $desktop-wide-grid-gap-width;
    padding: 0;
    display: flex;
    position: relative;
    z-index: 0;
  }

  &__content-left-col {
    width: calc($desktop-wide-grid-col-width * 3 + $desktop-wide-grid-gap-width * 2);
    min-width: calc($desktop-wide-grid-col-width * 3 + $desktop-wide-grid-gap-width * 2);
    gap: $desktop-wide-grid-gap-width;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: relative;
  }

  &__content-left-col-in-wrap1 {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  &__content-left-col-in-wrap2 {
    gap: $desktop-wide-grid-gap-width;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    position: sticky;
    inset: 0 auto auto 0;
  }

  &__content-right-col {
    flex-grow: 1;
    gap: $desktop-wide-grid-gap-width;
    display: flex;
    flex-direction: column;
  }

  &__messages-thread-wrap {
    flex-grow: 1;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
  }

  &__messages-thread {
    flex-grow: 1;
    min-height: 350px;
  }

  &__work-status-snippet {
  }

  &__collab-details-snippet {
  }

  &__how-it-works-snippet {
  }

  &__white-snippet-wrap {
    flex-grow: 1;
    width: 100%;
    padding: 20px 25px 24px;
    box-sizing: border-box;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 3px 15px -5px rgba(0, 0, 0, 0.4);
  }

  &__gray-snippet-wrap {
    width: 100%;
    padding: 20px 25px 24px;
    box-sizing: border-box;
    border-radius: 6px;
    background: #f0f0f0;
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
  .custom-collab-details-page {
    width: $desktop-right-col-width;

    &__content {
      gap: $desktop-grid-gap-width;
    }

    &__content-left-col {
      width: calc($desktop-grid-col-width * 3 + $desktop-grid-gap-width * 2);
      min-width: calc($desktop-grid-col-width * 3 + $desktop-grid-gap-width * 2);
      gap: $desktop-grid-gap-width;
    }

    &__content-left-col-in-wrap2 {
      gap: $desktop-grid-gap-width;
    }

    &__content-right-col {
      gap: $desktop-grid-gap-width;
    }
  }
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
  .custom-collab-details-page {
    width: $laptop-right-col-width;

    &__content {
      gap: $laptop-grid-gap-width;
    }

    &__content-left-col {
      width: calc($laptop-grid-col-width * 4 + $laptop-grid-gap-width * 3);
      min-width: calc($laptop-grid-col-width * 4 + $laptop-grid-gap-width * 3);
      gap: $laptop-grid-gap-width;
    }

    &__content-left-col-in-wrap2 {
      gap: $laptop-grid-gap-width;
    }

    &__content-right-col {
      gap: $laptop-grid-gap-width;
    }
  }
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
  .custom-collab-details-page {
    width: $tablet-large-content-width;

    &__content {
      gap: $tablet-large-grid-gap-width;
    }

    &__content-left-col {
      width: calc($tablet-large-grid-col-width * 4 + $tablet-large-grid-gap-width * 3);
      min-width: calc($tablet-large-grid-col-width * 4 + $tablet-large-grid-gap-width * 3);
      gap: $tablet-large-grid-gap-width;
    }

    &__content-left-col-in-wrap2 {
      gap: $tablet-large-grid-gap-width;
    }

    &__content-right-col {
      gap: $tablet-large-grid-gap-width;
    }
  }
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .custom-collab-details-page {
    width: $tablet-content-width;

    &__content {
      gap: $tablet-grid-gap-width;
      flex-direction: column;
    }

    &__content-left-col {
      width: 100%;
      min-width: 100%;
      gap: $tablet-grid-gap-width;
    }

    &__content-left-col-in-wrap2 {
      height: auto;
      gap: $tablet-grid-gap-width;
    }

    &__messages-thread {
      min-height: 500px;
    }

    &__content-right-col {
      gap: $tablet-grid-gap-width;
    }
  }
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .custom-collab-details-page {
    width: $mobile-content-width;

    &__content {
      gap: $mobile-grid-gap-width;
      flex-direction: column;
    }

    &__content-left-col {
      width: 100%;
      min-width: 100%;
      gap: $mobile-grid-gap-width;
    }

    &__content-left-col-in-wrap2 {
      height: auto;
      gap: $mobile-grid-gap-width;
    }

    &__messages-thread {
      min-height: 500px;
    }

    &__content-right-col {
      gap: $mobile-grid-gap-width;
    }
  }
}
</style>
